module.exports = __webpack_public_path__ + "img/cheeks.1ae536f4.svg";